import { CHATBOT_STATE } from './../actions/chatbotView.action';
import { IChatbotViewState } from "../models/root.interface";

const initialState: IChatbotViewState = {
    isVisible: false
}

const chatbotViewReducer = (state: IChatbotViewState = initialState, action: any): IChatbotViewState => {

    switch (action.type) {
        case CHATBOT_STATE:
            return {
                ...state,
                isVisible: action.isVisible
            }
        default:
            return state;
    }
}

export default chatbotViewReducer;